import MDinput from '@/components/MDinput';
import Select from '@/components/DSE/Select';
import { validatorRequire, validatorRequireNumber, validatorConditionalRequiredNumber } from '@/utils/validators';
import Switch from '@/components/DSE/Switch';
import { ProductTypeOption } from '@/utils/constants';
import CrudProduct from '../components/CrudProduct';
import i18n from '@/i18n';

export function getFormDefinition(vue) {
  return {
    type: 'tab',
    saveButtons: [true, false, false], // Page, tab 1, tab 2, ...
    showFormLabels: [true, false], // Tab 1, tab 2, ....
    labels: ['common.tabDetails', 'productType.products'],
    names: ['details', 'products'],
    header: form => {
      return {
        props: {
          title: form.description || i18n.t('common.productType')
        }
      };
    },
    groups: [
      {
        products: {
          type: CrudProduct,
          defaultValue: [],
          props: {
            caption: 'common.emptyString',
            openInFullscreen: false,
            parentIdFilterField: 'productTypeID',
            permissionCode: 'ProductType'
          }
        },
        description: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 32,
            required: true
          },
          rules: [{ validator: validatorRequire }]
        },
        productTypeOption: {
          type: Select,
          defaultValue: '',
          props: {
            caption: 'common.productType',
            valueField: 'code',
            labelField: 'description',
            loading: vue.$store.getters['option/isLoading'],
            options: vue.$store.getters['option/loadedOptions']('producttype'),
            required: true
          },
          rules: [{ validator: validatorRequireNumber }]
        },
        veloursYN: {
          type: Switch,
          defaultValue: false,
          valueOnFormChange: (form, oldValue) => {
            if (form.productTypeOption !== ProductTypeOption.Fabric) {
              return false;
            }
            return oldValue;
          },
          props: {
            activeText: 'common.yes',
            inactiveText: 'common.no',
            caption: 'productType.velours'
          },
          dynamicProps: form => ({
            visible: form.productTypeOption === ProductTypeOption.Fabric
          })
        },
        fabricTypeOption: {
          type: Select,
          defaultValue: null,
          valueOnFormChange: (form, oldValue) => {
            if (form.productTypeOption !== ProductTypeOption.Fabric) {
              return null;
            }
            return oldValue;
          },
          props: {
            caption: 'productType.fabricTypeOption',
            required: true,
            valueField: 'code',
            labelField: 'description',
            loading: vue.$store.getters['option/isLoading'],
            options: vue.$store.getters['option/loadedOptions']('fabrictype')
          },
          dynamicProps: form => ({
            visible: form.productTypeOption === ProductTypeOption.Fabric
          }),
          dynamicRules: form => [
            { validator: validatorConditionalRequiredNumber(form.productTypeOption === ProductTypeOption.Fabric) }
          ]
        },
        unitID: {
          type: Select,
          defaultValue: '',
          props: {
            caption: 'common.unit',
            required: true,
            valueField: 'id',
            labelField: 'description',
            loading: vue.$store.getters['unit/isLoading'],
            options: vue.$store.getters['unit/loadedItems']
          },
          rules: [{ validator: validatorRequireNumber }]
        },
        stockUnitID: {
          type: Select,
          defaultValue: null,
          props: {
            caption: 'common.stockUnit',
            valueField: 'id',
            labelField: 'description',
            loading: vue.$store.getters['unit/isLoading'],
            options: vue.$store.getters['unit/loadedItems']
          }
        },
        parcelTypeID: {
          type: Select,
          defaultValue: null,
          props: {
            caption: 'common.parcelType',
            valueField: 'id',
            labelField: 'description',
            loading: vue.$store.getters['parcelType/isLoading'],
            options: vue.$store.getters['parcelType/loadedItems']
          }
        },
        measurementRequiredYN: {
          type: Switch,
          defaultValue: false,
          props: {
            activeText: 'common.yes',
            inactiveText: 'common.no',
            caption: 'productType.measurementRequiredYN'
          }
        }
      }
    ]
  };
}

const layoutTabVariants = {
  named: true,
  sections: [
    {
      width: 100,
      fields: ['products']
    }
  ]
};
const layoutTabDetails = {
  named: true,
  sections: [
    {
      width: 100,
      fields: [
        'description',
        'productTypeOption',
        'veloursYN',
        'fabricTypeOption',
        'unitID',
        'stockUnitID',
        'parcelTypeID',
        'measurementRequiredYN'
      ]
    }
  ]
};

export function getCreateLayoutDefinition(vue) {
  return {
    groups: [layoutTabDetails]
  };
}
export function getEditLayoutDefinition(vue) {
  return {
    groups: [layoutTabDetails, layoutTabVariants]
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
